import React from "react";
import useCanonical from "../../helper/useCanonical";
import privacyPolicy from "../../assets/other/privacy-policy.png";

const PrivacyPolicy = () => {
  useCanonical(
    "/privacy-policy",
    "Privacy Policy | Sarcasm",
    "Read Sarcasm's Privacy Policy to understand how we collect, use, protect, and manage your personal information, cookies, and data preferences."
  );
  return (
    <>
      <section className="about-wrap-layout-1 space-top-60 space-bottom-60 space-top-md-30 space-bottom-md-30 bg-color-selago transition-default">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-4 order-lg-2">
              <div className="about-box-layout-1 radius-default">
                <div className="figure-holder radius-medium img-height-100">
                  <img src={privacyPolicy} />
                </div>
              </div>
            </div>
            <div className="col-lg-8 order-lg-1">
              <div className="about-box-layout-1 pe-lg-5">
                <div className="content-holder">
                  <h2 className="entry-title color-dark-1-fixed">
                    Privacy Policy
                  </h2>
                  <p className="entry-description color-dark-1-fixed">
                    At Sarcasm.co, we respect your privacy and are committed to
                    protecting any personal information you share with us. This
                    Privacy Policy explains how we collect, use, and safeguard
                    your data when you visit our website, which features news
                    and articles across marketing, sports, and entertainment. By
                    using Sarcasm.co, you agree to the practices described in
                    this policy.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="privacy-policy-container space-top-60 space-bottom-30 space-top-md-30 space-bottom-md-30">
        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <p>
            When you interact with Sarcasm.co, we may collect both personal and
            non-personal information. Personal information includes details like
            your name and email address, typically provided when you sign up for
            our newsletter, contact us, or submit comments. Non-personal data,
            such as your IP address, browser type, device information, and usage
            behavior, is automatically collected to help us better understand
            our audience and improve the performance of our website.
          </p>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <p>
            We use the information collected to enhance your experience on
            Sarcasm.co. This includes delivering content that aligns with your
            interests, sending occasional updates or newsletters if you’ve
            subscribed, and responding to your inquiries or feedback. We also
            analyze user behavior to optimize our site’s performance, track
            engagement, and maintain security. Rest assured, your personal data
            is never sold or used for purposes beyond those stated here.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Use of Cookies and Tracking Technologies</h2>
          <p>
            Sarcasm.co uses cookies and similar tracking technologies to
            personalize your browsing experience. Cookies help us remember your
            preferences, analyze site traffic, and deliver relevant
            advertisements through services like Google AdSense. You can manage
            or disable cookies in your browser settings; however, doing so may
            limit some features on our site.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Sharing of Information</h2>
          <p>
            We do not sell your personal information to third parties. However,
            we may share limited data with trusted service providers who assist
            us with website operations, email delivery, analytics, and
            advertising. In certain situations, we may also disclose your
            information if required by law, in response to legal processes, or
            to protect the rights and safety of Sarcasm.co and its users.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Third-Party Content and Links</h2>
          <p>
            Sarcasm.co may contain links to third-party websites or embedded
            content such as videos, tweets, or social media posts. These
            external sites operate independently and have their own privacy
            practices. We encourage you to review their policies, as Sarcasm.co
            is not responsible for the privacy practices or content of any
            third-party sites.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Data Security</h2>
          <p>
            We take reasonable steps to protect your personal information from
            unauthorized access, misuse, or disclosure. While we implement
            appropriate technical and organizational measures, please understand
            that no method of data transmission over the internet is completely
            secure. You use our website at your own risk.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Children’s Privacy</h2>
          <p>
            Sarcasm.co is intended for a general audience and is not directed
            toward children under the age of 13. We do not knowingly collect
            personal information from minors. If you believe that a child has
            submitted personal data to our site, please contact us immediately
            so we can take appropriate action.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Your Rights and Choices</h2>
          <p>
            You have control over your personal information. At any time, you
            can request access to, correction of, or deletion of your data. If
            you have subscribed to our emails, you can unsubscribe using the
            link in any of our communications. You can also adjust cookie
            settings in your browser if you wish to limit tracking.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Updates to This Privacy Policy</h2>
          <p>
            We may occasionally update this Privacy Policy to reflect changes in
            our practices or to comply with legal requirements. Any
            modifications will be posted on this page with the updated effective
            date. We encourage you to review this policy periodically.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Contact Us</h2>
          <p>
            If you have any questions, concerns, or requests related to this
            Privacy Policy or your personal data, please reach out:
          </p>
          <ul className="privacy-contact">
            <li>
              📧 Email:{" "}
              <a href="mailto:connect@sarcasm.co">connect@sarcasm.co</a>
            </li>
            <li>
              🌐 Website:{" "}
              <a
                href="https://www.sarcasm.co"
                target="_blank"
                rel="noopener noreferrer"
              >
                sarcasm.co
              </a>
            </li>
          </ul>
        </section>
      </div>
    </>
  );
};

export default PrivacyPolicy;
